import { ConfigContext, TopConfig } from './context/ConfigContext';
import logFactory from 'c9-js-log-client';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import { setLogger } from './utils/logger';
import { SubmitContextProvider } from './context/SubmitContext';
import { Message, ResourceContextProvider } from '@flos/react-ui';

let context = (window as any) || {};

context.ClaimFormApp = (function () {
    function bootstrapApplication(topConfig: TopConfig, bootstrapElement: any) {
        const logger = logFactory(topConfig.endpointConfig.logger, topConfig.appName, topConfig.logLevel);
        setLogger(logger);

        function ErrorFallback({ error }: { error: Error }) {
            console.error(error.message);
            logger.error('ClaimFormApp - ErrorBoundary caught', 'ErrorBoundary', {
                errorMessage: error.message,
                errorStack: error.stack
            });
            return (
                <Message large title={<h1>Der opstod en uventet fejl</h1>}>
                    <p>Der er desværre sket en fejl. Prøv igen. Kontakt os, hvis problemet fortsætter.</p>
                </Message>
            );
        }

        const root = ReactDOM.createRoot(bootstrapElement);
        root.render(
            <ConfigContext.Provider value={topConfig}>
                <ErrorBoundary FallbackComponent={ErrorFallback} onError={() => {}}>
                    <SubmitContextProvider>
                        <ResourceContextProvider
                            resourceEndpoint={[
                                `${topConfig.endpointConfig.resourceBundle}/dk.claim.fileclaim.responsetime`
                            ]}
                            initialResource={{}}
                        >
                            <App />
                        </ResourceContextProvider>
                    </SubmitContextProvider>
                </ErrorBoundary>
            </ConfigContext.Provider>
        );
    }

    return bootstrapApplication;
})();
